module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "m-b-20 ovf-hd"
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('router-link', {
    staticClass: "btn-link-large add-btn",
    attrs: {
      "to": "add"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("  添加应用\n      ")])])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "描述",
      "prop": "description"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "类型",
      "prop": "type",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_vm._v("\n          " + _vm._s(_vm._f("appType")(scope.row.type)) + "\n        ")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', [_c('router-link', {
          staticClass: "btn-link edit-btn m-r-5",
          attrs: {
            "to": {
              name: 'appEdit',
              params: {
                id: scope.row.id
              }
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row.id)
            }
          }
        }, [_vm._v("删除")])])]
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-29bf5dd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/application/list.vue
// module id = 1801
// module chunks = 2